import React from 'react'
import { Link } from 'gatsby'
import {
  FooterContainer,
  FooterInner,
  FooterColumn,
  FooterItem,
  FooterSocial,
  FooterTerms,
  PdfNotation,
  ActivateSimButton,
  GooglePlayStoreImage,
  IosAppImage,
} from './styles'
import googlePlayStore from '../../static/images/app-landing-page/google-play-store.svg'
import iosApp from '../../static/images/app-landing-page/ios-app.svg'
import { TRACKING_CATEGORIES } from '../../constants/globalStrings'

const Footer = () => (
  <FooterContainer role="contentinfo" data-testid="footer-container">
    <FooterInner>
      <FooterColumn>
        <FooterItem>
          <a
            href="https://help.smarty.co.uk/all-about-smarty/terms-conditions"
            data-testid="footer-terms-link"
          >
            Terms and conditions
          </a>
        </FooterItem>
        <FooterItem>
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-privacy-link"
          >
            Privacy policy <PdfNotation>(PDF)</PdfNotation>
          </a>
        </FooterItem>
        <FooterItem>
          <a href="/accessibility" data-testid="footer-accessibility-link">
            Accessibility
          </a>
        </FooterItem>
        <FooterItem>
          <a
            href="https://cdn.smarty.co.uk/files/smarty-vulnerability-policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-vulnerability-link"
          >
            Vulnerable situations policy <PdfNotation>(PDF)</PdfNotation>
          </a>
        </FooterItem>
        <FooterItem>
          <a
            href="/cookies"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cookies-link"
          >
            Cookies policy <PdfNotation>(PDF)</PdfNotation>
          </a>
        </FooterItem>
        <FooterItem>
          <button
            id="ot-sdk-btn"
            className="ot-sdk-show-settings cookie-pref-btn"
          >
            Cookie preferences
          </button>
        </FooterItem>
        <FooterItem>
          <a
            href="/complaints"
            rel="noreferrer"
            data-testid="footer-complaints-link"
          >
            Complaints
          </a>
        </FooterItem>
      </FooterColumn>
      <FooterColumn>
        <FooterItem>
          <Link to="/free-sim" data-testid="footer-free-sim-link">
            Free SIM
          </Link>
        </FooterItem>
        <FooterItem>
          <Link to="/sim-only" data-testid="footer-sim-only-link">
            SIM only
          </Link>
        </FooterItem>
        <FooterItem>
          <Link to="/pay-as-you-go" data-testid="footer-payg-link">
            Pay as you go
          </Link>
        </FooterItem>
        <FooterItem>
          <Link to="/data-sim" data-testid="footer-data-sim-link">
            Data SIM
          </Link>
        </FooterItem>
        <FooterItem>
          <Link
            to="/no-credit-check-sim"
            data-testid="footer-no-credit-check-link"
          >
            No credit check
          </Link>
        </FooterItem>
        <FooterItem>
          <Link to="/plans/unlimited" data-testid="footer-unlimited-link">
            Unlimited SIM
          </Link>
        </FooterItem>
        <FooterItem>
          <Link to="/student-sim" data-testid="footer-student-link">
            Student SIM
          </Link>
        </FooterItem>
        <FooterItem>
          <Link to="/data-rollover" data-testid="footer-data-rollover-link">
            Data Rollover
          </Link>
        </FooterItem>
        <FooterItem>
          <Link to="/5g" data-testid="footer-5g-link">
            5G
          </Link>
        </FooterItem>
        <FooterItem>
          <Link
            to="/free-wifi-on-london-underground"
            data-testid="footer-free-wifi-on-london-underground-link"
          >
            Free Wifi on London Underground
          </Link>
        </FooterItem>
      </FooterColumn>
      <FooterColumn>
        <FooterItem>
          <a
            href="https://help.smarty.co.uk"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-support-link"
          >
            Support
          </a>
        </FooterItem>
        <FooterItem>
          <a href="/contact" data-testid="footer-contact-link">
            Contact us
          </a>
        </FooterItem>
        <FooterItem>
          <a href="/app" data-testid="footer-app-link">
            App
          </a>
        </FooterItem>
        <FooterItem>
          <a
            href="/priceguide"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-price-guide-link"
          >
            Price guide <PdfNotation>(PDF)</PdfNotation>
          </a>
        </FooterItem>
        <FooterItem>
          <a
            href="/roaming"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-roaming-link"
          >
            Roaming &amp; International
          </a>
        </FooterItem>
        <FooterItem>
          <a
            href="/blog"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-blog-link"
          >
            Blog
          </a>
        </FooterItem>
        <FooterItem>
          <a
            href="http://www.three.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-three-link"
          >
            three.co.uk
          </a>
        </FooterItem>
      </FooterColumn>
      <FooterColumn>
        <FooterItem>
          <ActivateSimButton>
            <a href="/activate" data-testid="activate-sim-button">
              Activate SIM
            </a>
          </ActivateSimButton>
        </FooterItem>
        <FooterItem>
          <a
            href="https://apps.apple.com/app/apple-store/id1540812668?pt=421745&mt=8&ct=smarty_web_download"
            rel="noopener noreferrer"
            target="_blank"
            aria-label="iOS App"
            data-testid="footer-ios-app-download-link"
            data-item-name="ios-app-download-link"
            data-item-category={TRACKING_CATEGORIES.NAVIGATION}
          >
            <IosAppImage alt="Ios App" data-testid="ios-app" src={iosApp} />
          </a>
        </FooterItem>
        <FooterItem>
          <a
            href="https://play.google.com/store/apps/details?id=com.hutchison3g.sundae&referrer=utm_source%3Dsmarty%26utm_medium%3Dweb%26utm_content%3Dappstore_logo"
            rel="noopener noreferrer"
            target="_blank"
            aria-label="Google play store App"
            data-testid="footer-android-app-download-link"
            data-item-name="android-app-download-link"
            data-item-category={TRACKING_CATEGORIES.NAVIGATION}
          >
            <GooglePlayStoreImage
              alt="Google Play Store App"
              data-testid="google-play-store-app"
              src={googlePlayStore}
            />
          </a>
        </FooterItem>
      </FooterColumn>
    </FooterInner>
    <FooterSocial>
      <span data-testid="footer-social-span">Follow SMARTY</span>
      <a
        href="https://www.facebook.com/SMARTYMobile"
        rel="noopener noreferrer"
        target="_blank"
        id="facebook"
        data-testid="footer-facebook-icon"
      >
        Facebook
      </a>
      <a
        href="https://twitter.com/smartymobileuk"
        rel="noopener noreferrer"
        target="_blank"
        id="twitter"
        data-testid="footer-twitter-icon"
      >
        Twitter
      </a>
    </FooterSocial>
    <FooterTerms>
      <p data-testid="footer-copyright">
        © {new Date().getFullYear()} All rights reserved. SMARTY.
      </p>
      <p>
        <a href="/" data-testid="footer-self-link">
          smarty.co.uk
        </a>
      </p>
      <p data-testid="footer-personal-use">
        SMARTY is a service that’s just for consumers and is only intended for
        personal use.
      </p>
      <p data-testid="footer-trading">
        SMARTY is a trading name of Hutchison 3G UK Limited
      </p>
      <div>
        <p data-testid="footer-address">
          Registered office: Hutchison 3G UK Limited, 450 Longwater Avenue,
          Green Park, Reading, Berkshire, RG2 6GF
        </p>

        <p data-testid="footer-comp-num">
          Registered in England & Wales Number 03885486
        </p>
        <p data-testid="footer-vat">VAT Registration Number 760 7292 22</p>
      </div>
    </FooterTerms>
  </FooterContainer>
)

export default Footer
